const FOCUSABLE_SELECTOR = [
  'a[href]',
  'button:not([disabled])',
  'textarea:not([disabled])',
  'input:not([disabled])',
  'select:not([disabled])',
  '[tabindex]:not([tabindex="-1"])',
].join(', ');

export function getFocusableElements(container) {
  if (!container) return [];
  return Array.from(container.querySelectorAll(FOCUSABLE_SELECTOR)).filter((node) => {
    if (node.hasAttribute('disabled')) return false;
    if (node.getAttribute('aria-hidden') === 'true') return false;
    if (node.tabIndex < 0) return false;
    return true;
  });
}

export function trapTabKey(event, container) {
  if (event.key !== 'Tab' || !container) return;
  const items = getFocusableElements(container);
  if (!items.length) {
    event.preventDefault();
    container.focus();
    return;
  }
  const first = items[0];
  const last = items[items.length - 1];
  if (event.shiftKey && document.activeElement === first) {
    event.preventDefault();
    last.focus();
  } else if (!event.shiftKey && document.activeElement === last) {
    event.preventDefault();
    first.focus();
  }
}

export function focusInitialElement(container, initialFocusRef) {
  const requested = initialFocusRef?.current;
  if (requested && typeof requested.focus === 'function') {
    requested.focus();
    return;
  }
  const items = getFocusableElements(container);
  const target = items[0] || container;
  if (target && typeof target.focus === 'function') {
    target.focus();
  }
}
